<template>  
  <div class="modal-card modal-card--md">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Compare
      </p>
      <a class="close-modal" aria-label="close" @click="closeModal()">
        <i class="material-icons">close</i>
      </a>
    </header>
    <section class="modal-card-body">
     
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class CompareModal extends Vue {

  public closeModal() {
    this.$store.commit('setModal', '');
  }

}

</script>

<style scoped lang="scss">

</style>